import { buildOfferHtml } from './offerTemplates';

export const getNestedValue = (obj: any, path: string): any => {
  const segments = path.split('.');
  let current = obj;
  for (const segment of segments) {
    if (current === null || typeof current !== 'object') {
      return undefined;
    }
    current = current[segment];
  }
  return current;
};

export const isTruthy = (value: any): boolean => {
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (typeof value === 'number') return value !== 0;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value).length > 0;
  return Boolean(value);
};

export const calculatePlacementFee = (monthlySalary: number | null): number | null => {
  if (monthlySalary === null || !Number.isFinite(monthlySalary) || monthlySalary <= 0) return null;
  return Math.max(2000, monthlySalary * 0.1);
};

export const applyTemplate = (template: string, values: any): string => {
  if (!template) {
    return buildOfferHtml(values);
  }

  let html = template;
  const conditionalRegex = /\{%\s*if\s+([\w.]+)\s*%\}([\s\S]*?)\{%\s*endif\s*%\}/g;
  const matches = [];
  let match;
  while ((match = conditionalRegex.exec(html)) !== null) {
    matches.push({
      fullMatch: match[0],
      variablePath: match[1],
      content: match[2],
      index: match.index,
    });
  }

  matches.reverse().forEach(({ fullMatch, variablePath, content, index }) => {
    const value = getNestedValue(values, variablePath);
    if (isTruthy(value)) {
      html = html.slice(0, index) + content + html.slice(index + fullMatch.length);
    } else {
      html = html.slice(0, index) + html.slice(index + fullMatch.length);
    }
  });

  const placeholderRegex = /\{\{([\w.]+)\}\}|\$\{([\w.]+)\}/g;
  html = html.replace(placeholderRegex, (placeholder, curlyPath, dollarPath) => {
    const path = curlyPath || dollarPath;
    const value = getNestedValue(values, path);
    if (value === undefined || value === null) return '';
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  });

  return html;
};
